// Custom breakpoint for hamburger menu.
// Added because Nav bar no longer fits all menu items using the standard breakpoints.
// The hamburger menu should show when the screen width is < 1070px
// The Primary nav should show when the screen width is >= 1070px
export const NAV_BREAKPOINT = "1070px";

// Offsets used to calculate the margin-top of the main content area for different screen sizes
// Also used to calculate the height of the gradient background
export const CONTENT_OFFSET_MOBILE = 2.5; // rem
export const CONTENT_OFFSET_TABLET = 4; // rem
export const CONTENT_OFFSET_DESKTOP = 7.5625; // rem
